import { Component, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { ProductService } from '../../../services/product.service';
import { Product } from '../../../models/product.model';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { FormsModule } from '@angular/forms';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { TableModule } from 'primeng/table';
import { DropdownModule } from "primeng/dropdown";
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { debounceTime, distinctUntilChanged, Subject, Subscription } from 'rxjs';
import { PaginatorModule } from 'primeng/paginator';
import { TooltipModule } from 'primeng/tooltip';
import { GroupService } from '../../groups/group.service';


@Component({
  selector: 'app-list-product',
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    ConfirmDialogModule,
    ToastModule,
    FormsModule,
    DropdownModule,
    InputTextModule,
    CheckboxModule,
    PaginatorModule,
    TooltipModule
],
  templateUrl: './list-product.component.html'
})
export class ListProductComponent implements OnInit {

  private searchSubject = new Subject<string>();
  private searchSubscription?: Subscription;

  status = [
    {label: 'Todos', value: null},
    { label: 'Ativos', value: true },
    { label: 'Inativos', value: false }
  ];

  products: Product[] = [];
  searchTerm = '';
  selectedStatus = this.status[0].value;
  loading = true;
  minimumStock: boolean = false;
  negativeStock: boolean = false;
  
  first: number = 0;
  rows: number = 5;
  totalRecords: number = 0;
  currentPage: number = 1;
  private groupsById = new Map<number, string>();

  constructor(
    private productService: ProductService,
    private groupService: GroupService,
    public router: Router,
    // private confirmService: ConfirmationService,
    // private message: MessageService
  ) {
    this.searchSubscription = this.searchSubject.pipe(
          debounceTime(300),
          distinctUntilChanged()
        ).subscribe(term => {
          this.searchTerm = term;
          this.loadProducts();
        });
  }

  ngOnInit(): void {
    this.loadGroups();
    this.loadProducts();
  }

  loadGroups(): void {
    this.groupService.getAll('', true, false, null).subscribe({
      next: (data) => {
        this.groupsById = new Map(
          (data.data ?? []).map((group: { id: number; description: string }) => [group.id, group.description])
        );
      }
    });
  }

  onStatusChange(){
    this.loadProducts();
  }

  onSearchChange(){
    this.searchSubject.next(this.searchTerm);
  }

  loadProducts() {
    this.loading = true;
    this.productService.getAll(this.searchTerm, this.selectedStatus, this.minimumStock, this.negativeStock, this.currentPage).subscribe({
      next: (data) => {
        this.products = data.data;
        this.totalRecords = data.pagination.totalRecords;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

   onPageChange(event: any): void {
    this.first = event.first;
    this.currentPage = Math.floor(this.first / this.rows) + 1;
    this.loadProducts();
  }

   createProduct() {
    this.router.navigate(['/app/products/new']);
  }

   edit(product: Product) {
    this.router.navigate(['/app/products/edit', product.id]);
  }

  duplicate(product: Product): void {
    this.router.navigate(['/app/products/new'], { queryParams: { duplicateFrom: product.id } });
  }

  export(){
    this.productService.export(this.searchTerm, this.selectedStatus, this.minimumStock, this.negativeStock).subscribe({
      next: (file) => {
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
      },
      error: (error) => {
        console.log(error);
      }
    });
  }

  getFamilyLabel(product: Product): string {
    const desc = product.family?.description?.trim();
    if (desc) {
      return desc;
    }
    return product.familyId != null ? `Família #${product.familyId}` : '-';
  }

  getSectorLabel(product: Product): string {
    const desc = product.sector?.description?.trim();
    if (desc) {
      return desc;
    }
    return product.sectorId != null ? `Setor #${product.sectorId}` : '-';
  }

  getSubgroupLabel(product: Product): string {
    const desc = product.subgroup?.description?.trim();
    if (desc) {
      return desc;
    }
    return product.subgroupId != null ? `Subgrupo #${product.subgroupId}` : '-';
  }

  getGroupLabel(product: Product): string {
    const productWithGroup = product as Product & {
      groupDescription?: string;
      groupName?: string;
      group?: { description?: string; name?: string };
    };

    if (productWithGroup.groupDescription) {
      return productWithGroup.groupDescription;
    }

    if (productWithGroup.groupName) {
      return productWithGroup.groupName;
    }

    if (productWithGroup.group?.description) {
      return productWithGroup.group.description;
    }

    if (productWithGroup.group?.name) {
      return productWithGroup.group.name;
    }

    if (product.groupId && this.groupsById.has(product.groupId)) {
      return this.groupsById.get(product.groupId) ?? '-';
    }

    return product.groupId ? `Grupo #${product.groupId}` : '-';
  }
}